export const LMT_ENHCMT_flushUploadResponsesReducer = {
  LMT_ENHCMT_flushUploadResponses: (state, action) => {
    state.s3FileUploadAPICall.uploadFileResponses = [null, null, null, null];
    state.screenConstHistory = [];
  },
};
